import { ICommonIconProps } from "../types";

/**
 * -----------------------------------------------------------------------------
 * Renders a additional device info icon with a device and a question mark icon.
 */
export function AdditionalDeviceInfoIcon({ className }: ICommonIconProps) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M8.75 18.5H11.25"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M15 12.977V19C15 20.105 14.105 21 13 21H7C5.895 21 5 20.105 5 19V7C5 5.895 5.895 5 7 5H10.6"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M19.3891 3.61091C21.537 5.75879 21.537 9.2412 19.3891 11.3891C17.2412 13.537 13.7588 13.537 11.6109 11.3891C9.46305 9.2412 9.46305 5.75879 11.6109 3.61091C13.7588 1.46303 17.2412 1.46303 19.3891 3.61091"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M15.5 10.415C15.47 10.415 15.445 10.44 15.445 10.47C15.445 10.5 15.47 10.525 15.5 10.525C15.53 10.525 15.555 10.5 15.555 10.47C15.555 10.44 15.53 10.415 15.5 10.415Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M15.5 8.188C16.449 8.188 17.219 7.418 17.219 6.469C17.219 5.52 16.45 4.75 15.5 4.75C14.574 4.75 13.825 5.483 13.788 6.4"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
